import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native"
import ChangeInformationScreen from '../ChangeInformationScreen';
import {
    serviceActionSetState,
    serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSetWallet
} from "../../../splash/action/ActionSplashGetAllData";
import i18n from "../../../../../I18n/i18n";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import * as NavigationService from "../../../../../redux/NavigationService";
import base64 from "react-native-base64";
import HMAlert from "../../../../../customviews/HMAlert";
import {Tools} from "../../../../../tools/Tools";

const mapStateToProps = (state) => ({
    results: state.reducerChangeInformationScreen.results,
    NoInternetDialog: state.reducerChangeInformationScreen.NoInternetDialog,
    isLoading: state.reducerChangeInformationScreen.isLoading,

    user: state.reducerSplashGetAllData.user,
    token: state.reducerSplashGetAllData.token,
    DataSplashScreen: state.reducerSplashGetAllData,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callserviceActionRefresh: (user) => dispatch(serviceActionRefresh(user)),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),


})

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {
    switch (type) {

        case typeExport.TypegetDataChangeInformationScreen:
            dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetDataChangeInformationScreen:
            dispatch(serviceActionPendingSet());

            break;
        default:
    }

    /* axios(
         {
             url: baseUrl + url + params,
             method: typeConnection,
             headers: {
                 'Content-Type': 'application/x-www-form-urlencoded',
                 "Authorization":  token,

             },

         }
     )*/
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": `Basic ${params.token}`
        }
    };
    const formData = new FormData();
    formData.append('_operation', typeExport._Contacts);
    formData.append('mode', "UpdateContact");
    formData.append('lang', params.lang);
    formData.append('token', params.token);
    formData.append('firstname', params.firstname);
    formData.append('lastname', params.lastname);
    formData.append('NationalCode', params.NationalCode);
    formData.append('Phone', params.Phone);
    formData.append('SocialNetworkNumber', params.SocialNetworkNumber);
    formData.append('Address', params.Address);
    formData.append('Description', params.Description);
    formData.append('token_fb', store.getState().reducerSplashGetAllData.token_fb);
    Tools.addAllFormData(formData)
  //  axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Basic ${params.token}`
        },
        timeout: typeExport._TIMEOUT,

    })
        .then(async response => {
            let data = response.data;
            switch (type) {

                case typeExport.TypegetDataChangeInformationScreen:
                   HMAlert(i18n.t('constant.message'), "ویرایش با موقیت انجام شد", [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {text: i18n.t('constant.ok'), onPress: () => NavigationService.Pop()},
                        ],
                        {cancelable: true}
                    )
                    dispatch(serviceActionSuccess(data))
                    if (data.success === true) {
                        if (data.result.user !== null && data.result.user !== undefined) {
                            await AsyngStorageClass.setAsyng(typeExport._USER, data.result.user);
                            dispatch(serviceActionSetUser(data.result.user))
                        }

                    }
                    break;
                case typeExport.TypeSetDataChangeInformationScreen:

                    dispatch(serviceActionSuccessSet(data))


                    break;
                default:
            }
        }).catch((e) => {
        switch (type) {

            case typeExport.TypegetDataChangeInformationScreen:
                dispatch(serviceActionError(e))

                break;
            case typeExport.TypeSetDataChangeInformationScreen:
                dispatch(serviceActionErrorSet(e))

                break;
            default:
        }

    })
}


export const callWebservice = (url, params, type, typeConnection, token) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection,token);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )


        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        } else {
            dispatch(serviceActionError("No Internet Connection"));
        }


        // NetInfo.getConnectionInfo().).done(
        //     (isConnected) => {
        //
        //     }
        // )

    }
}


export const serviceActionPending = () => ({
    type: typeExport.ChangeInformationScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.ChangeInformationScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.ChangeInformationScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.ChangeInformationScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})

export const serviceActionPendingSet = () => ({
    type: typeExport.ChangeInformationScreen_SERVICE_PENDING_SET,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.ChangeInformationScreen_SERVICE_ERROR_SET,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.ChangeInformationScreen_SERVICE_SUCCESS_SET,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,


})

export const serviceActionRefreshSet = () => ({
    type: typeExport.ChangeInformationScreen_SERVICE_REFRESH_SET,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: null
})
export default connect(mapStateToProps, mapDispatchToProps)(ChangeInformationScreen);
